import { render } from "./employee-salary.vue?vue&type=template&id=5235eecd"
import script from "./employee-salary.vue?vue&type=script&lang=js"
export * from "./employee-salary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__